import {deleteMethod, getMethod, postMethod} from '~/api'

async function remove(request) {
    return await deleteMethod('/proxy/companiesCustomFilters', request)
}

async function post(request) {
    return await postMethod('/proxy/companiesCustomFilters', request)
}

async function get(request) {
    return await getMethod('/proxy/companiesCustomFilters', request)
}

export {post, get, remove}
